export default __webpack_public_path__ + "static/media/Whistleblowing_2_(DK).262bf551.mp4";